import Vue from 'vue';
import App from './App';
import VueTheMask from 'vue-the-mask';
import './registerServiceWorker';
import router from './router';
import store from './store';
import axios from 'axios';
import vuetify from './plugins/vuetify';
import { resolver as resolverAtribuicao } from './utils/attribution';

Vue.config.productionTip = false;

store.commit('aplicarAtribuicao', resolverAtribuicao());

Vue.use(VueTheMask);

// (window.location.hostname == 'localhost')
const baseURL = (document.URL.indexOf('localhost') !== -1)
    ? 'http://localhost:8000/api'
    : 'https://webservice.zapermenu.com.br/api';

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const http = axios.create({ baseURL });

Vue.prototype.$http = http;
Vue.prototype.$urlAPI = baseURL;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
